import { BehaviorSubject } from 'rxjs';

import { CoordinatorService } from './coordinator.service';
import { ReportField } from './report-field';
import { ReportSection } from './report-section';
import { Report } from './report';

export class Report$ {
    fieldMap = new Map<string, ReportField>();
    sectionMap = new Map<string, ReportSection>();

    setTab$ = new BehaviorSubject<string>('project');

    currentSection$: BehaviorSubject<ReportSection>;
    currentSubset$ = new BehaviorSubject<string | null>(null);

    private _report?: Report;

    // excludeMiscSet = new Set<string>();

    constructor(public coords: CoordinatorService) {
        new ReportField(this, 'mainSize', true);

        [
            new ReportSection(this.coords, {
                tag: 'project-details',
                type: 'table',
            }),
            new ReportSection(this.coords, {
                tag: 'references',
                type: 'list',
            }),
        ].forEach((x) => this.sectionMap.set(x.tag, x));
        this.currentSection$ = new BehaviorSubject<ReportSection>(this.sectionLs[1]);
    }

    clear() {
        this._report = undefined;
    }

    get sectionLs() {
        return Array.from(this.sectionMap.values());
    }

    docx(lang: string = 'cz', includeAbstracts = false) {
        this.generateReport(lang, includeAbstracts);
    }

    publishDialog() {
        // const pub = new Publication(this.coords, this._report!.initPublicationData);
        // pub.dialog();
    }

    private generateReport(lang: string, includeAbstracts: boolean) {
        const report = this.coords.report$.get();
        const projectFields = [
            'title',
            'client',
            'clientContact',
            'ntkResearcher',
            'startDate',
            'deliveryDate',
            'keyWords',
            'description',
            'limitation',
            'notes',
        ];

        const selectedSubset = report.itemSource;
        const sourceDataSet = this.coords.dataset$.main.allXitemLs.filter((xitem) =>
            selectedSubset.has(xitem.id),
        );

        const referenceData = sourceDataSet.map((xitem) => xitem.templateValues);

        const citations = referenceData.map((item, index) => {
            return {
                index: index + 1,
                reference: item.get('id'),
                hasTitle: !!item.get('title'),
                title: item.get('title') || '',
                hasAuthors: !!item.get('authorLs'),
                authors: item.get('authorLs')?.join('; ') || '',
                hasYear: !!item.get('year'),
                year: item.get('year') || '',
                hasSource: !!item.get('source'),
                source: item.get('source') || '',
                hasDoi: !!item.get('doi'),
                doi: item.get('doi') || '',
                hasDoiUrl: !!item.get('doi'),
                doiUrl: item.get('doi') ? `https://dx.doi.org/${item.get('doi')}` : '',
                hasAbstract: includeAbstracts ? sourceDataSet[index].abstract?.length > 0 : false,
                abstract: includeAbstracts ? sourceDataSet[index].abstract || '' : '',
            };
        });

        const projectProps: { [tag: string]: any } = {};

        const rp = this.get();
        rp.dataMap.forEach((value, tag) => {
            if (value !== undefined || value !== null || value !== '') {
                if (tag === 'startDate' || tag === 'deliveryDate') {
                    projectProps[tag] = this.coords.utils$.tryFormatDate(value);
                } else {
                    projectProps[tag] = value;
                }
            }
        });

        const reportPayload = Object.assign({}, projectProps, {
            numberOfRecords: citations?.length,
            citations,
        });

        this.coords.worker$.report.directPost({
            action: 'create-docx',
            payload: {
                lang,
                reportPayload,
            },
        });
    }

    get() {
        if (!this._report) this._report = new Report(this.coords);
        // this._report.update()
        return this._report;
    }

    previewDialog(
        languages = ['cz'],
        includeAbstracts = false,
        citationStyle = 'ACS (American Chemical Society)',
    ) {
        this.coords.display$.dialog$.next({
            action: 'report-project-preview',
            languages,
            includeAbstracts,
            citationStyle,
        });
    }
}
